module.exports = __webpack_public_path__ + "img/ejoyGo.660d4aef.svg";